let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ltkYf")).then(() => parcelRequire('2ao8s'));